import React from 'react'
import { Stack, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'

interface BadInformationDetailDetectionOverviewProps {
  data: any
}

const priorityRiskKeys = [
  'bad_info_detail_score_B',
  'bad_info_detail_score_C',
  'bad_info_detail_score_D',
  'bad_info_detail_score_E',
  'bad_info_detail_score_F',
  'bad_info_detail_score_G',
]

const criminalRecordKeys = [
  'bad_info_detail_score_A_1',
  'bad_info_detail_score_A_2',
  'bad_info_detail_score_A_3',
  'bad_info_detail_score_A_4',
  'bad_info_detail_score_A_5',
  'bad_info_detail_score_A_6',
  'bad_info_detail_score_A_7',
]

export default function BadInformationDetailDetectionOverview({ data }: BadInformationDetailDetectionOverviewProps) {
  const theme = useTheme()

  const countRisks = (keys: string[]) => {
    return keys.filter((key) => data?.[key] && data[key] !== '0').length
  }

  const priorityRiskCount = countRisks(priorityRiskKeys)
  const criminalRecordCount = countRisks(criminalRecordKeys)
  const totalRiskCount = priorityRiskCount + criminalRecordCount

  const overallStatus = totalRiskCount > 0 ? '检测到风险' : '暂无风险'

  return (
    <div className="mt-2">
      <Stack gap="md">
        <div className="flex flex-col gap-2">
          <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
            不良信息检测概览
          </Text>
          <Text size="xs" className="text-gray-500">
            汇总重点风险和前科风险的整体检测结果,包括风险项数量及总体评估。
          </Text>
        </div>
        <div className="grid gap-3 md:grid-cols-3">
          <SummaryItem label="重点风险项数" value={`${priorityRiskCount} / 6 项`} subtitle="涉赌、涉毒、在逃等" />
          <SummaryItem label="前科风险项数" value={`${criminalRecordCount} / 7 项`} subtitle="金融、财产、人身等" />
          <SummaryItem label="总体风险评估" value={overallStatus} subtitle={`共检测 ${totalRiskCount} 项风险`} />
        </div>
      </Stack>
    </div>
  )
}

interface SummaryItemProps {
  label: string
  value: string
  subtitle?: string
}

function SummaryItem({ label, value, subtitle }: SummaryItemProps) {
  const theme = useTheme()

  return (
    <div
      className="rounded-lg border px-4 py-3"
      style={{ borderColor: theme.surfaceBorderColor, backgroundColor: theme.surfaceColor }}
    >
      <Text size="xs" className="text-gray-500">
        {label}
      </Text>
      <Text size="sm" fw={600} style={{ marginTop: '6px', color: theme.primaryColor }}>
        {value}
      </Text>
      {subtitle && (
        <Text size="xs" className="text-gray-400" style={{ marginTop: '4px' }}>
          {subtitle}
        </Text>
      )}
    </div>
  )
}
